/**
 * Zengen — AOV-Booster: zufällige Produktvorschläge im Warenkorb-Fortschrittsbalken.
 *
 * Liquid rendert bis zu 8 verfügbare Kandidaten aus dem passenden Tag-Pool, alle mit
 * `hidden`. Dieses Skript blendet daraus zufällig `data-show` Karten ein.
 *
 * WICHTIG: Cart-Re-Renders laufen über DOM-Morphing (assets/morph.js), nicht über
 * kompletten Ersatz. Der Server liefert die Karten immer mit `hidden`, daher würde
 * ein reines connectedCallback-only-Reveal beim nächsten Morph wieder zurückgesetzt.
 * Deshalb hören wir zusätzlich auf dasselbe Cart-Update-Event wie gift-progress.js.
 */
(() => {
  class AovBoosterComponent extends HTMLElement {
    connectedCallback() {
      this.reveal();
    }

    reveal() {
      const cards = Array.from(this.querySelectorAll('[data-aov-card]'));
      cards.forEach((card) => card.setAttribute('hidden', ''));
      if (!cards.length) return;

      const show = parseInt(this.dataset.show || '3', 10) || 3;
      for (let i = cards.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [cards[i], cards[j]] = [cards[j], cards[i]];
      }
      cards.slice(0, show).forEach((card) => card.removeAttribute('hidden'));
    }
  }

  if (!customElements.get('aov-booster-component')) {
    customElements.define('aov-booster-component', AovBoosterComponent);
  }

  function revealAll() {
    document.querySelectorAll('aov-booster-component').forEach((el) => {
      if (el instanceof AovBoosterComponent) el.reveal();
    });
  }

  document.addEventListener('DOMContentLoaded', revealAll);

  (async () => {
    try {
      const { StandardEvents } = await import('@shopify/events');
      document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
        const promise = event && event.promise;
        if (!promise) {
          revealAll();
          return;
        }
        promise.then(revealAll).catch(() => {});
      });
    } catch (e) {
      console.warn('[aov-booster] Cart-Event-Listener konnte nicht registriert werden.', e);
    }
  })();
})();
